import React from "react";
import "./Basket_crane_rental.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";
import { Helmet } from "react-helmet";

export default function Crane_Rental1() {

  const seo = {
    title:
      "השכרת מנוף זרוע | מנוף זרוע להרמה ופריקה | ש.מ הובלות ומנופים",
    description:
      "שירותי השכרת מנוף זרוע להרמה, העמסה, פריקה ושינוע של ציוד כבד ומטענים. ש.מ הובלות ומנופים מספקת שירותי מנוף זרוע לקבלנים, חברות, מפעלים, עסקים, אנשי מקצוע ולקוחות פרטיים ברחבי הארץ.",
    url:
      "https://smtovala.co.il/Crane_Rental1",
    image:
      "https://smtovala.co.il/images/37.jpeg"
  };

  return (
    <div className="Crane_work_nationwide-page">

      {/* =====================================================
          SEO
      ===================================================== */}

      <Helmet>

        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        {/* Open Graph */}

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:title"
          content={seo.title}
        />

        <meta
          property="og:description"
          content={seo.description}
        />

        <meta
          property="og:url"
          content={seo.url}
        />

        <meta
          property="og:image"
          content={seo.image}
        />

        <meta
          property="og:site_name"
          content="ש.מ הובלות ומנופים"
        />

        <meta
          property="og:locale"
          content="he_IL"
        />

        {/* Twitter */}

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={seo.title}
        />

        <meta
          name="twitter:description"
          content={seo.description}
        />

        <meta
          name="twitter:image"
          content={seo.image}
        />

      </Helmet>


      {/* =====================================================
          HERO - כותרת עליונה
      ===================================================== */}
   <div className="Basket_crane_rental-page">


      <div className="Basket_crane_rental-hero">

        <div className="Basket_crane_rental-overlay">

          <h1>השכרת מנוף זרוע</h1>

        </div>

      </div>

      </div>
 


      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">


          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              השכרת מנוף זרוע
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >

                <source
                  src="/video/25.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.

              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי השכרת מנוף הזרוע של ש.מ הובלות ומנופים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">

            השכרת מנוף זרוע היא פתרון יעיל לעבודות הרמה,
            העמסה, פריקה ושינוע של ציוד ומטענים במגוון אתרים.
            ש.מ הובלות ומנופים מספקת שירותי מנוף זרוע לקבלנים,
            חברות, מפעלים, עסקים, אנשי מקצוע ולקוחות פרטיים,
            תוך התאמת אמצעי ההרמה למשקל המטען, למרחק העבודה
            ולתנאים הקיימים באתר.

          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">

              <img
                src="/images/37.jpeg"
                alt="השכרת מנוף זרוע"
              />

            </div>

            <div className="text-box">

              <p>
                מנוף זרוע מאפשר לבצע פעולות הרמה ושינוע כאשר
                המטען צריך לעבור מהמשאית אל נקודת יעד או מהאתר
                אל המשאית. לפני תחילת העבודה חשוב לבחון את משקל
                המטען, מידותיו, מרחק ההרמה, גובה העבודה ואת
                האפשרות להציב את המשאית בנקודה המתאימה.
              </p>

              <p>
                ש.מ הובלות ומנופים מעניקה שירותי מנוף זרוע
                להרמת ציוד כבד, חומרי בניין, מכונות, משטחים,
                מתקנים ומטענים שונים. השירות מותאם לצורכי
                הפרויקט ולתנאי הגישה במקום שבו מתבצעת העבודה.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            השכרת מנוף זרוע – התאמת המנוף למשימה
          </h2>

          <div className="bottom-text">

            <p>
              כל עבודת הרמה מתחילה בהבנת דרישות המשימה. יש לבדוק
              מהו משקל המטען, מהן המידות שלו, לאיזה גובה הוא צריך
              להגיע ומהו המרחק בין המשאית לבין נקודת ההצבה.
            </p>

            <p>
              חשוב לבדוק גם את תנאי האתר, אפשרויות הכניסה והיציאה,
              מיקום המשאית והמרחב שבו ניתן לבצע את פעולת ההרמה.
              תכנון מוקדם מאפשר להתאים את אופן העבודה לתנאים
              הקיימים בשטח.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              מנוף זרוע להרמת ציוד כבד
            </h2>

            <p>
              מנוף זרוע יכול לשמש להרמה והעברה של ציוד במשקלים
              שונים, בהתאם ליכולת המנוף ולדרישות העבודה. הוא
              מאפשר להעביר מטענים מנקודה אחת לאחרת ולהציב אותם
              במיקום שנקבע מראש.
            </p>

            <p>
              השירות מתאים בין היתר להרמת מכונות, ציוד תעשייתי,
              מתקנים, משטחים, קורות, חומרי בניין ומטענים נוספים,
              בהתאם למאפייני העבודה ולתנאי האתר.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              השכרת מנוף זרוע לאתרי בנייה, מפעלים ועסקים
            </h2>

            <p>
              באתרי בנייה ובמתחמים תעשייתיים ועסקיים יש צורך
              לעיתים קרובות בהעברת ציוד וחומרי עבודה אל אזורים
              שאינם נגישים ישירות באמצעות אמצעי שינוע רגילים.
              מנוף זרוע יכול לתת מענה למשימות מסוג זה.
            </p>

            <p>
              ש.מ הובלות ומנופים מספקת שירותי מנוף זרוע לאתרי
              בנייה, מפעלים, מחסנים, עסקים ופרויקטים שונים ברחבי
              הארץ, בהתאם לסוג המטען, לנקודת העבודה ולתנאי הגישה.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              מנוף זרוע להעמסה ופריקה של מטענים
            </h2>

            <p>
              אחת השימושים המרכזיים במנוף זרוע היא ביצוע פעולות
              העמסה ופריקה. כאשר המטען כבד או כאשר אין אפשרות
              לפרוק אותו באמצעות ציוד רגיל, ניתן להיעזר במנוף
              לצורך העברתו מהמשאית אל אזור היעד.
            </p>

            <p>
              ניתן לתכנן את פעולת הפריקה בהתאם למיקום המטען,
              למרחק מנקודת ההצבה ולתנאים בשטח. כך ניתן להתאים
              את העבודה לצורכי האתר ולסדר הפעולות הנדרש.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              מנוף זרוע להרמת חומרי בניין וציוד לאתר
            </h2>

            <p>
              בענף הבנייה נעשה שימוש במנוף זרוע להעברת חומרי
              בניין וציוד אל אזורים שונים באתר. בין המטענים
              שניתן לשנע נמצאים משטחים, קורות, לוחות, מתקנים,
              מכונות וציוד עבודה.
            </p>

            <p>
              התאמת העבודה מתבצעת לפי משקל המטען, מידותיו,
              טווח ההרמה, נקודת הפריקה ומיקום המשאית. תכנון
              נכון של הפעולה מסייע לבצע את ההרמה בהתאם לתנאי
              האתר ולדרישות הפרויקט.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור שירות מקצועי להשכרת מנוף זרוע?
            </h2>

            <p>
              עבודות הרמה של מטענים כבדים דורשות התייחסות
              למשקל המטען, לטווח העבודה, למיקום המשאית ולתנאי
              השטח. לפני תחילת העבודה חשוב להבין כיצד ניתן
              לבצע את ההעמסה, ההרמה והפריקה בהתאם לתנאים בפועל.
            </p>

            <p>
              ש.מ הובלות ומנופים בוחנת את מאפייני המשימה ומתאימה
              את פתרון מנוף הזרוע לסוג המטען, למשקל, למרחק
              ההרמה, לנקודת ההצבה ולדרישות העבודה.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              ש.מ הובלות ומנופים – השכרת מנוף זרוע ברחבי הארץ
            </h2>

            <p>
              ש.מ הובלות ומנופים מספקת שירותי מנוף זרוע להרמה,
              העמסה, פריקה ושינוע של ציוד ומטענים עבור קבלנים,
              חברות, מפעלים, עסקים, אנשי מקצוע ולקוחות פרטיים.
              השירות ניתן בהתאם למאפייני המטען ולתנאים הקיימים
              במקום העבודה.
            </p>

            <p>
              צריכים מנוף זרוע להרמה או לפריקה? צרו קשר עם
              ש.מ הובלות ומנופים ומסרו לנו את משקל המטען,
              המידות, גובה ההרמה, נקודת האיסוף והיעד. נבחן
              את פרטי העבודה ונכוון אתכם לפתרון המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Basket_crane_rental"
              className="link-right"
            >
              השכרת מנוף סל
            </Link>

            <Link
              to="/Hourly_Lifting_Basket_Rental"
              className="link-left"
            >
              השכרת סל הרמה לפי שעה
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
